export default __webpack_public_path__ + "static/media/embed.95f24693.svg";